module.exports = __webpack_public_path__ + "img/52002734_L.813c30ea.png";